import { RoleListResolver } from './resolvers/role-list.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './components/user/user.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { UserRegionsComponent } from './components/user-regions/user-regions.component';
import { IsSysAdminGuard } from '../guard/is-sys-admin.guard';


const routes: Routes = [
  { path: '', redirectTo: 'user', pathMatch: 'full' },
  { path: 'user', component: UserManagementComponent, canActivate: [IsSysAdminGuard],  resolve: { roles: RoleListResolver } },
  { path: 'region', component: UserRegionsComponent, resolve: { roles: RoleListResolver }}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
